import { addPreloadToLCP } from './utils/LCPFile';
window.addEventListener('load', () => {
    addPreloadToLCP();
});